import { HttpMethods } from "../enums/HttpMethods";
import { DataWrapper } from "../interfaces/DataWrapper";
import { Language } from '../interfaces/Language';
import { Site } from '../interfaces/Site';
import ContentFeedService from "./contentFeed.service";
import qs from 'qs';

const SORT = `?sort[0]=id:asc`

class BaseService {
  public static getAllByParams(entity: string, column?: string, inputValue?: string): Promise<Site[] | Language[]> {
    let query;

    if (column && inputValue) {
      query = qs.stringify({
        filters: {
          [column]: { $containsi: inputValue }
        }
      });
    }

    return ContentFeedService.sendRequest<DataWrapper<Site[] | Language[]>>(HttpMethods.GET, `${entity}${column ? `?${query}` : `${SORT}`}`)
      .then((wrappedLanguages: DataWrapper<Site[]>) => wrappedLanguages.data)
      .catch((error: Error) => {
        throw error;
      });
  }
}

export default BaseService;
